export default "__VITE_ASSET__DUi$vu1G__"